//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { BodyBoldText, BodyText } from '@components/atoms/text/Text';
import { pluralize } from '@utils/stringUtils';

interface SuccessViewProps {
  count: number;
}

export const SuccessView = ({ count }: SuccessViewProps) => (
  <StyledStateContainer>
    <BodyBoldText>Summary</BodyBoldText>
    <BodyText>{pluralize(count, 'product')} imported</BodyText>
  </StyledStateContainer>
);

export const StyledStateContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[2]};
  `}
`;
